import { marked } from "marked";
import React, { useCallback, useEffect, useState } from "react";
import { parse } from "semver";
import { Modal, useModal } from "./Modal";
import { oblacDrivesBrandId, makeCdnUrl } from "motion-master-client";

const FirmwareChangelog = ({ version }) => {
  const { isOpen, open, close } = useModal();
  const [changelog, setChangelog] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const parseVersionToFileName = () => {
    const isSubpatch = /\+/g.test(version);

    if (isSubpatch) {
      return `${encodeURIComponent(version)}.md`;
    }

    const { major, minor } = parse(version);

    return `v${major}.${minor}.md`;
  };

  const changeLogUrl = makeCdnUrl(`/brands/${oblacDrivesBrandId}/changelogs/${parseVersionToFileName()}`);

  const handleModalOpen = () => {
    fetchChangelog();
    open();
  };

  useEffect(() => {
    setTimeout(() => {
      document.querySelectorAll(".modal-body h1, .modal-body h2").forEach((el) => {
        if (el.textContent.trim().startsWith(version)) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }, [changelog]);

  const fetchChangelog = useCallback(() => {
    if (isFetching) return;

    setIsFetching(true);

    fetch(changeLogUrl)
      .then((res) => {
        if (res.ok) return res.text();
        throw new Error(res.statusText);
      })
      .then((md) => {
        setFetchError(null);
        setChangelog(marked.parse(md ?? ""));
      })
      .catch((res) => {
        console.error(res);
        setFetchError(res);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [isFetching]);

  return (
    <>
      <button type="button" onClick={handleModalOpen} title="Show firmware changelog" className="dropdown-item">
        Changelog
      </button>
      <Modal title="Firmware changelog" isOpen={isOpen} size="lg" isScrollable={true} onClose={close}>
        {fetchError && <strong>{fetchError.message}</strong>}
        {changelog && <div dangerouslySetInnerHTML={{ __html: changelog }}></div>}
        {isFetching && !fetchError && <strong role="status">Loading...</strong>}
      </Modal>
    </>
  );
};

export default FirmwareChangelog;
